import { useState, useEffect } from 'react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'Do you work with insurance companies?',
      answer: 'Yes! We work with all major insurance companies, warranty providers, and extended warranty companies. We can handle the entire claims process for you and provide direct billing to make the process as smooth as possible.'
    },
    {
      question: 'How long does a typical repair take?',
      answer: 'Repair time varies depending on the extent of damage. Minor repairs can be completed in 1-2 days, while major collision repairs may take 5-7 days. We provide accurate time estimates during your free consultation and keep you updated throughout the process.'
    },
    {
      question: 'Do you offer free estimates?',
      answer: 'Absolutely! We provide free, no-obligation estimates for all repair work. Simply bring your vehicle to our Brooklyn location or call us at (631) 933-7887 to schedule an appointment.'
    },
    {
      question: 'Do you provide towing service?',
      answer: 'Yes! We offer 24/7 emergency towing service throughout Brooklyn, Manhattan, Queens, and all NYC boroughs. If your vehicle is disabled or involved in an accident, call us at (631) 933-7887 and we\'ll dispatch a tow truck immediately to bring your vehicle to our shop.'
    },
    {
      question: 'What areas do you serve?',
      answer: 'We are located in Brooklyn\'s Industrial Area and serve all of Brooklyn, Manhattan, Queens, and surrounding New York areas. We also offer roadside assistance and towing services for customers who need help getting their vehicle to our shop.'
    },
    {
      question: 'Are your mechanics certified?',
      answer: 'Yes, all our mechanics are certified professionals with extensive training and experience. Our team has been serving the Brooklyn community for over 30 years, and we stay current with the latest automotive repair techniques and technologies.'
    },
    {
      question: 'Do you provide warranty on repairs?',
      answer: 'Yes, we stand behind our work with comprehensive warranties on all repairs. We also honor manufacturer warranties and work with extended warranty providers to ensure your coverage is maintained.'
    }
  ];

  useEffect(() => {
    // Add FAQ Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map(faq => ({
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faq.answer
        }
      }))
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 font-['Playfair_Display']">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Get answers about our auto repair services, insurance work, and more
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <article
              key={index}
              className="bg-white rounded-2xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-lg"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer hover:bg-gray-50 transition-colors"
              >
                <h3 className="text-lg font-bold text-gray-900 pr-4">
                  {faq.question}
                </h3>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-orange-600 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-8 pb-6">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
